import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Box, Tab, Tabs, Typography } from "@material-ui/core";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Group from "../../waybee-ui/Group";
import Heading from "../../waybee-ui/Heading";
import AccessControl from "./AccessControl/AccessControl";
import ClassAccess from "./ClassAccess/ClassAccess";

const PageHeader = styled.div`
  margin-bottom: 8px;
`;

const PageSubtitle = styled(Typography)`
  && {
    color: #6b6b6b;
    margin-top: 4px;
    margin-bottom: 16px;
  }
`;

const SettingsTabs = styled(Tabs)`
  && {
    margin-bottom: 8px;
    border-bottom: 1px solid #ececec;
  }
`;

const Content = styled.div`
  padding-top: 16px;
`;

const getTabValue = pathname => {
  if (pathname.startsWith("/settings/class-access")) {
    return "class-access";
  }
  return "profiles";
};

const Settings = ({ history, location }) => {
  const { t } = useTranslation();
  const tabValue = getTabValue(location.pathname);

  const handleTabChange = (_event, value) => {
    if (value === "class-access") {
      history.push("/settings/class-access");
      return;
    }
    history.push("/settings/access-control");
  };

  return (
    <Box>
      <PageHeader>
        <Heading level={5}>{t("settings.pageTitle")}</Heading>
        <PageSubtitle>{t("settings.subtitle")}</PageSubtitle>
      </PageHeader>

      <Group>
        <SettingsTabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label={t("settings.tabs.profiles")} value="profiles" />
          <Tab label={t("settings.tabs.classAccess")} value="class-access" />
        </SettingsTabs>

        <Content>
          <Switch>
            <Route
              exact
              path="/settings"
              render={() => <Redirect to="/settings/access-control" />}
            />
            <Route
              exact
              path="/settings/access-control"
              component={AccessControl}
            />
            <Route
              exact
              path="/settings/class-access"
              component={ClassAccess}
            />
            <Redirect to="/settings/access-control" />
          </Switch>
        </Content>
      </Group>
    </Box>
  );
};

Settings.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired
};

export default withRouter(Settings);
